export const RANKING_TAB = {
  HOSPITAL: "hospital",
  SURGEON: "surgeon",
}

export const SUBSPECIALTIES = {
  ALL: "All",
  HIP_AND_KNEE: "Hip & Knee",
  FOOT_AND_ANKLE: "Foot & Ankle",
  SHOULDER_AND_ELBOW: "Shoulder & Elbow",
  HAND_AND_WRIST: "Hand & Wrist",
  SPINE: "Spine",
  ORTHOPEDIC_ONCOLOGY: "Orthopedic Oncology",
}

export const DATA_LIMIT = 10

export const HOSPITAL_TYPE = {
  TEACHING: 1,
  COMMUNITY: 0,
  ALL: "All",
}

export const PERCENTILE_BUCKET = {
  hospital: {
    HOSPITAL_TYPE: "bucket",
    ALL: "bucket",
  },
  surgeon: {
    ALL: "bucket_all",
    SUBSPECIALTY: "bucket_subspecialty",
  },
}

export const DRAWER_POSITION = {
  LEFT: "left",
  RIGHT: "right",
  BOTTOM: "bottom",
  TOP: "top",
}

export const PERCENTILE_TAB = {
  FIRST: 1,
  SECOND: 2,
  THIRD: 3,
  FOURTH: 4,
}

export const ROUTES = {
  HOSPITAL:
    "/best-orthopedic-spine-surgeons-hospitals-research-all-stars/?type=hospitals",
  SURGEON:
    "/best-orthopedic-spine-surgeons-hospitals-research-all-stars/?type=surgeons",
}

export const EMAIL = {
  SUBJECT: "Please Provide my Research All-Star Badge",
  RECEIPIENT_EMAIL: "Research.All-Stars@avantgardehealth.com",
  BODY: "I would like to promote my Research All-Star status. Please send my Research All-Star Badge. Thanks!",
}

export const ALL_STAR_MAIL_LINK = `mailto:${EMAIL.RECEIPIENT_EMAIL}`

export const AGH_NETWORK = {
  LINKED_IN: "https://www.linkedin.com/company/avant-garde-health",
  FACEBOOK: "https://www.facebook.com/AvantgardeHealthOfficial",
  TWITTER: "https://twitter.com/avantgarde",
  WEBSITE: "https://avantgardehealth.com",
}

export const SHOW_PASSWORD_ON_ALL_START_PAGE = false

export const INTERSECTION_OBSERVER_OPTION = {
  root: null,
  rootMargin: "-20px",
  threshold: 0,
}

export const ALL_STAR_PAGES_URL = {
  LANDING: "pre-launch-research-all-stars",
  FAQ: "research-all-stars-FAQ",
  PRE_LAUNCH_FAQ: "pre-launch-research-all-stars-FAQ",
  BADGES: "research-all-stars-badges",
  SOCIAL_MEDIA_TEMPLATES: "research-all-stars-social-media-templates",
  PRESS_RELEASE_TEMPLATE: "research-all-stars-press-release-template",
  HOME: "best-surgeons-and-hospitals-research-all-stars",
  KEY_FINDINGS: "research-all-stars-key-findings",
  METHODOLOGY: "research-all-stars-methodology",
  PRE_LAUNCH_METHODOLOGY: "pre-launch-research-all-stars-methodology",
}

export const BADGES = {
  2024: [
    {
      name: "Overall Hospital All-Stars",
      image: "Research All-Stars 2024 - Hospitals",
      pageSlug: "/best-hospitals-healthcare-research-all-stars/",
    },
    {
      name: "General Surgery",
      image: "Research All-Stars 2024 - General Surgery",
      pageSlug: "/best-general-surgery-surgeons-hospitals-research-all-stars/",
    },
    {
      name: "Orthopedic Surgery",
      image: "Research All-Stars 2024 - Orthopedic Surgery",
      pageSlug: "/best-orthopedic-surgeons-hospitals-research-all-stars/",
    },
    {
      name: "Hip & Knee Surgery",
      image: "Research All-Stars 2024 - Hip & Knee Surgery",
    },
    {
      name: "Foot & Ankle Surgery",
      image: "Research All-Stars 2024 - Foot & Ankle",
    },
    {
      name: "Shoulder & Elbow Surgery",
      image: "Research All-Stars 2024 - Shoulder & Elbow",
    },
    {
      name: "Hand & Wrist Surgery",
      image: "Research All-Stars 2024 - Hand & Wrist",
    },
    {
      name: "Spine Surgery",
      image: "Research All-Stars 2024 - Spine",
      pageSlug: "/best-spine-surgeons-hospitals-research-all-stars/",
    },
    {
      name: "Neurosurgery",
      image: "Research All-Stars 2024 - Neurosurgery Surgery",
      pageSlug: "/best-neurosurgeons-hospitals-research-all-stars/",
    },
    {
      name: "Cardiothoracic Surgery",
      image: "Research All-Stars 2024 - Cardiothoracic Surgery",
      pageSlug: "/best-cardiothoracic-surgeons-hospitals-research-all-stars/",
    },
    {
      name: "Vascular Surgery",
      image: "Research All-Stars 2024 - Vascular Surgery",
      pageSlug: "/best-vascular-surgeons-hospitals-research-all-stars/",
    },
    {
      name: "ENT Surgery",
      image: "Research All-Stars 2024 - ENT Surgery",
      pageSlug: "/best-otolaryngology-surgeons-hospitals-research-all-stars/",
    },
    {
      name: "GI Surgery",
      image: "Research All-Stars 2024 - GI Surgery",
      pageSlug: "/best-gastrointestinal-surgeons-hospitals-research-all-stars/",
    },
    {
      name: "Urology",
      image: "Research All-Stars 2024 - Urology",
      pageSlug: "/best-urology-surgeons-hospitals-research-all-stars/",
    },
    {
      name: "Surgical Oncology",
      image: "Research All-Stars 2024 - Surgical Oncology",
      pageSlug: "/best-oncology-surgeons-hospitals-research-all-stars/",
    },
  ],
  2025: [
    {
      name: "Overall Hospital All-Stars",
      image: "Healthcare Research All-Stars 2025 - Logo",
      pageSlug: "/best-hospitals-healthcare-research-all-stars-2025/",
    },
    {
      name: "Orthopedic Surgery",
      image: "Healthcare Research All-Stars 2025 - Orthopedic Surgery Logo",
      pageSlug: "/best-orthopedic-hospitals-research-all-stars-2025/",
    },
    {
      name: "Sports Medicine",
      image: "Healthcare Research All-Stars 2025 - Sports Logo",
      pageSlug: "/best-sport-medicine-hospitals-research-all-stars-2025/",
    },
    {
      name: "Hand Surgery",
      image: "Healthcare Research All-Stars 2025 - Hand Surgery Logo",
      pageSlug: "/best-hand-surgery-hospitals-research-all-stars-2025/",
    },
    {
      name: "Neurosurgery & Spine",
      image:
        "Healthcare Research All-Stars 2025 - Neurosurgery Spine Surgery Logo",
      pageSlug: "/best-brain-spine-hospitals-research-all-stars-2025/",
    },
    {
      name: "Cardiothoracic Surgery",
      image: "Healthcare Research All-Stars 2025 - Cardiothoracic Surgery Logo",
      pageSlug:
        "/best-cardiothoracic-surgery-hospitals-research-all-stars-2025/",
    },
    {
      name: "Vascular Surgery",
      image: "Healthcare Research All-Stars 2025 - Vascular Surgery Logo",
      pageSlug: "/best-vascular-surgery-hospitals-research-all-stars-2025/",
    },
    {
      name: "ENT (Otolaryngology)",
      image: "Healthcare Research All-Stars 2025 - ENT Surgery Logo",
      pageSlug: "/best-ent-otolaryngology-hospitals-research-all-stars-2025/",
    },
    {
      name: "GI/General Surgery",
      image: "Healthcare Research All-Stars 2025 - GI Surgery Logo",
      pageSlug: "/best-gi-surgery-hospitals-research-all-stars-2025/",
    },
    {
      name: "Urology",
      image: "Healthcare Research All-Stars 2025 - Urology Surgery Logo",
      pageSlug: "/best-urology-hospitals-research-all-stars-2025/",
    },
    {
      name: "Surgical Oncology",
      image: "Healthcare Research All-Stars 2025 - Oncology Surgery Logo",
      pageSlug: "/best-surgical-oncology-hospitals-research-all-stars-2025/",
    },
    {
      name: "Ophthalmology",
      image: "Healthcare Research All-Stars 2025 - Opthalmology Surgery Logo",
      pageSlug: "/best-ophthalmology-hospitals-research-all-stars-2025/",
    },
    {
      name: "Gynecologic Surgery",
      image: "Healthcare Research All-Stars 2025 - Gynecologic Surgery Logo",
      pageSlug: "/best-gynecology-hospitals-research-all-stars-2025/",
    },
    {
      name: "Internal Medicine",
      image: "Healthcare Research All-Stars 2025 - Internal Medicine Logo",
      pageSlug: "/best-internal-medicine-research-all-stars-2025/",
    },
    {
      name: "Cardiology",
      image: "Healthcare Research All-Stars 2025 - Cardiology Medicine Logo",
      pageSlug: "/best-cardiology-hospitals-research-all-stars-2025/",
    },
    {
      name: "Pulmonology",
      image: "Healthcare Research All-Stars 2025 - Pulmonology Medicine Logo",
      pageSlug: "/best-pulmonology-hospitals-research-all-stars-2025/",
    },
    {
      name: "Gastroenterology",
      image:
        "Healthcare Research All-Stars 2025 - Gastroenterology Medicine Logo",
      pageSlug: "/best-gastroenterology-hospitals-research-all-stars-2025/",
    },
    {
      name: "Endocrinology",
      image: "Healthcare Research All-Stars 2025 - Endocrinology Medicine Logo",
      pageSlug: "/best-endocrinology-hospitals-research-all-stars-2025/",
    },
    {
      name: "Nephrology",
      image: "Healthcare Research All-Stars 2025 - Nephrology Medicine Logo",
      pageSlug: "/best-nephrology-hospitals-research-all-stars-2025/",
    },
    {
      name: "Neurology",
      image: "Healthcare Research All-Stars 2025 - Neurology Medicine Logo",
      pageSlug: "/best-neurology-hospitals-research-all-stars-2025/",
    },
    {
      name: "Hematology",
      image: "Healthcare Research All-Stars 2025 - Hematology Medicine Logo",
      pageSlug: "/best-hematology-hospitals-research-all-stars-2025/",
    },
    {
      name: "Medical Oncology",
      image: "Healthcare Research All-Stars 2025 - Medical Oncology Logo",
      pageSlug: "/best-medical-oncology-hospitals-research-all-stars-2025/",
    },
    {
      name: "Rheumatology",
      image: "Healthcare Research All-Stars 2025 - Rheumatology Medicine Logo",
      pageSlug: "/best-rheumatology-hospitals-research-all-stars-2025/",
    },
  ],
}

export const excludedItems = [
  "Hip & Knee Surgery",
  "Foot & Ankle Surgery",
  "Shoulder & Elbow Surgery",
  "Hand & Wrist Surgery",
]

export const PERCENTILES = {
  TOP1: "top1",
  TOP3: "top3",
  TOP5: "top5",
}

export const SLIDER_INTERVAL = 15000

export const ALL_STAR_SURGEON_QUOTES = [
  {
    id: 1,
    quote: `"Diversity in the field of orthopedics has been a cornerstone of my work, ensuring that we create an inclusive environment where the voices of women are heard and valued. Alongside this, my commitment to evidence-based medicine has guided over 200 publications, highlighting the importance of rigorous research in advancing patient care. These twin pillars of my approach not only challenge the existing paradigms but also shape a future where healthcare benefits from a broad spectrum of perspectives. This journey, deeply personal and professional, drives my mission to enhance the medical community and the lives of those we serve."`,
    title: "Lisa Cannada, MD",
    description: "Orthopedic Trauma Surgeon, Novant Health",
    name: "Lisa Cannada",
  },
  {
    id: 2,
    quote: `"At Cleveland Clinic's Clinical Spine Lab, we've transitioned from basic science to publishing 30-40 impactful studies annually, aiming to advance the field of spine surgery. Under the guidance of leaders including Dr. Mroz and Steinmetz, our team focuses on making our research accessible to surgeons worldwide. The critical need for precise patient selection, to prevent unnecessary surgeries, highlights the importance of accurate diagnosis. By embracing value-based care, prioritizing quality over cost, we are setting a new standard for healthcare, ensuring that patient outcomes always come first"`,
    title: "Edward Benzel, MD",
    description: `Emeritus Chairman of the Department of Neurosurgery
    Cleveland Clinic`,
    name: "Edward Benzel",
  },
  {
    id: 3,
    quote: `"Building a core team of like-minded individuals who share a passion for advancing medicine through research is pivotal. This foundation enables us to tackle larger questions, secure funding, and explore various avenues of investigation. By maintaining a focus on outcomes, we ensure that our work not only contributes to academic growth but also enhances patient care and hospital practices. The purity of research, as we understand it, is embodied in the meticulous tracking of patient outcomes with the goal of continuous improvement."`,
    title: "Jeffrey Stambough, MD",
    description: "Adult Reconstructive Orthopedic Surgeon UAMS Health",
    name: "Jeffrey Stambough",
  },
  {
    id: 4,
    quote: `"My research is fundamentally driven by the conditions I encounter within my patient population, with a focus on finding ways to improve their outcomes. Specifically, in addressing the challenges posed by anaplastic thyroid cancer, I developed an animal model for the cancer. This critical step enabled us to delve into its genetics and assess the efficacy of various drugs. This work is a direct reflection of my commitment to enhance the care and outcomes for my patients, translating scientific inquiry into tangible improvements in patient treatment strategies."`,
    title: "Sareh Parangi, MD",
    description:
      "Chair of Surgery at Newton-Wellesley Hospital Director, MGH Thyroid Cancer Research Laboratory",
    name: "Sareh Parangi",
  },
  {
    id: 5,
    quote: `"We do clinical research because we strive to offer better options to our patients. We never want to face a patient and be forced to say we have no hope to offer. Through research, we're creating new standards of care that are guideline compliant, quality-assured and protocol driven. These new standards reign in the most precarious outliers - bad patient outcomes - as well as unnecessarily high costs. As we progress on the continuum of these objectives, we continue to improve the overall quality and value of healthcare."`,
    title: "Dean Kereiakes, MD",
    description:
      "Chairman of The Christ Hospital Heart and Vascular Institute, Medical Director of The Christ Hospital Research Institute",
    name: "Dean Kereiakes",
  },
  {
    id: 6,
    quote: `"My dedication to research is motivated by a commitment to advancing medical innovation and asking and answering important translational questions. As clinicians, this is our academic philanthropy which provides a balance to the daily responsibilities of caring for patients and educating our next generation of clinical scientists. It is satisfying and fulfilling to collaborate with colleagues in the they can be their best!"`,
    title: "Brian J. Cole, MD, MBA",
    description: `Acting Chair and Professor, Department of Orthopedics, Chair, Department of Surgery, Rush OPH, Shoulder,
     Elbow and Knee Surgery, Section Head, Cartilage Restoration Center at Rush`,
    name: "Bryan Cole",
  },
  {
    id: 7,
    quote: `"One of our core missions in research at Mass General Brigham is to uncover operational methods that enhance patient care. For instance, our analysis of many surgical cases pinpointed key factors leading to post-surgical complications. The insights gained drove us to adopt ERAS (Enhanced Recovery After Surgery) protocols. Consequently, through standardization and adherence by surgeons, we've seen an 83% decrease in surgical site infections. This initiative has also significantly lowered the incidence of embolisms and reduced prolonged use of narcotics post-surgery. These outcomes exemplify how dedicated research directly translates into tangible improvements in patient health and recovery."`,
    title: "Ronald Bleday, MD",
    description: `Vice Chair for Quality and Patient Safety, Department of Surgery
    Section Chief, Division of Colorectal Surgery
    Associate Professor, Harvard Medical School`,
    name: "Ronald Bleday",
  },
  {
    id: 8,
    quote: `"Jefferson extends exceptional support for research, providing us with allocated time each week
     to advance our work. In response, we dedicate ourselves to addressing critical challenges, guiding protocol improvements and elevating patient care. For instance, our findings have prompted changes that lower the risks of post-surgery infections and embolisms, both of which are serious and can be life-threatening."`,
    title: "Javad Parvizi, MD, FRCS",
    description: `Professor of Orthopedic Surgery, Thomas Jefferson University`,
    name: "Javad Parvizi",
  },
  {
    id: 9,
    quote: `"Our field's commitment to research improves the care of our patients in several ways. First,
    it improves our understanding of the causes and treatments of the disorders we encounter. Second, the process of research forces us all to maintain a firm command of the constantly evolving body of evidence in our discipline. This knowledge improves our patient care, training, and education."`,
    title: "David Gudis, MD, FACS, FARS",
    description: `Division Chief, Rhinology & Anterior Skull Base Surgery Department of Otolaryngology
    Head and Neck Surgery Columbia University Irving Medical Center`,
    name: "David Gudis",
  },
  {
    id: 10,
    quote: `"Research inherently demands sacrifices, both in terms of time and financial resources, yet it's
    our passion that fuels our success. There is a great sense of fulfillment when our research leads to advancements, particularly in addressing unresolved clinical challenges. Each breakthrough we achieve not only solves immediate clinical issues but also lays the groundwork for future medical advancements, benefiting patients for years to come."`,
    title: "Scott Rodeo, MD",
    description: `ATTENDING Surgeon at the Hospital for Special Surgery, Professor of Orthopaedic Surgery
     at Weill Medical College of Cornell University`,
    name: "Scott Rodeo",
  },
  {
    id: 11,
    quote: `"You can't provide cutting-edge cardiology treatment without conducting cutting-edge cardiology research. It's critical to do both. Not surprisingly, many of the top researchers in cardiology also have some of the busiest clinical practices.  And through research, we are recognizing and in many cases for the first time, successfully treating patients with previously unmet needs."`,
    title: "Timothy Henry, MD",
    description: `Medical Director of the Lindner Research Center, The Christ Hospital Research Institute`,
    name: "Timothy Henry",
  },
]

export const SPECIALTIES_LIST = {
  2025: {
    overall: {
      label: "Overall Hospital All-Stars",
      path: "/best-hospitals-healthcare-research-all-stars-2025/",
    },
    surgical: [
      {
        label: "Orthopedic Surgery",
        value: "Orthopedic Surgery",
        path: "/best-orthopedic-hospitals-research-all-stars-2025/",
      },
      {
        label: "Sports Medicine",
        value: "Sports Medicine",
        path: "/best-sport-medicine-hospitals-research-all-stars-2025/",
      },
      {
        label: "Hand Surgery",
        value: "Hand Surgery",
        path: "/best-hand-surgery-hospitals-research-all-stars-2025/",
      },
      {
        label: "Neurosurgery & Spine",
        value: "Neurosurgery & Spine",
        path: "/best-brain-spine-hospitals-research-all-stars-2025/",
      },
      {
        label: "Cardiothoracic Surgery",
        value: "Cardiothoracic Surgery",
        path: "/best-cardiothoracic-surgery-hospitals-research-all-stars-2025/",
      },
      {
        label: "Vascular Surgery",
        value: "Vascular Surgery",
        path: "/best-vascular-surgery-hospitals-research-all-stars-2025/",
      },
      {
        label: "ENT (Otolaryngology)",
        value: "ENT (Otolaryngology)",
        path: "/best-ent-otolaryngology-hospitals-research-all-stars-2025/",
      },
      {
        label: "GI/General Surgery",
        value: "GI/General Surgery",
        path: "/best-gi-surgery-hospitals-research-all-stars-2025/",
      },
      {
        label: "Urology",
        value: "Urology",
        path: "/best-urology-hospitals-research-all-stars-2025/",
      },
      {
        label: "Surgical Oncology",
        value: "Surgical Oncology",
        path: "/best-surgical-oncology-hospitals-research-all-stars-2025/",
      },
      {
        label: "Ophthalmology",
        value: "Ophthalmology",
        path: "/best-ophthalmology-hospitals-research-all-stars-2025/",
      },
      {
        label: "Gynecologic surgery",
        value: "Gynecologic surgery",
        path: "/best-gynecology-hospitals-research-all-stars-2025/",
      },
    ],
    medical: [
      {
        label: "Internal Medicine",
        value: "Internal Medicine",
        path: "/best-internal-medicine-research-all-stars-2025/",
      },
      {
        label: "Cardiology",
        value: "Cardiology",
        path: "/best-cardiology-hospitals-research-all-stars-2025/",
      },
      {
        label: "Pulmonology",
        value: "Pulmonology",
        path: "/best-pulmonology-hospitals-research-all-stars-2025/",
      },
      {
        label: "Gastroenterology",
        value: "Gastroenterology",
        path: "/best-gastroenterology-hospitals-research-all-stars-2025/",
      },
      {
        label: "Endocrinology",
        value: "Endocrinology",
        path: "/best-endocrinology-hospitals-research-all-stars-2025/",
      },
      {
        label: "Nephrology",
        value: "Nephrology",
        path: "/best-nephrology-hospitals-research-all-stars-2025/",
      },
      {
        label: "Neurology",
        value: "Neurology",
        path: "/best-neurology-hospitals-research-all-stars-2025/",
      },
      {
        label: "Hematology",
        value: "Hematology",
        path: "/best-hematology-hospitals-research-all-stars-2025/",
      },
      {
        label: "Medical Oncology",
        value: "Medical Oncology",
        path: "/best-medical-oncology-hospitals-research-all-stars-2025/",
      },
      {
        label: "Rheumatology",
        value: "Rheumatology",
        path: "/best-rheumatology-hospitals-research-all-stars-2025/",
      },
    ],
  },
}

export const SPECIALTIES_MAPPING = {
  overall: "Overall Hospital All-Stars",
  orthopedic: "Orthopedic Surgery",
  sports: "Sports Medicine",
  hand: "Hand Surgery",
  brain_spine: "Neurosurgery & Spine",
  cardiothoracic: "Cardiothoracic Surgery",
  vascular: "Vascular Surgery",
  ent: "ENT (Otolaryngology)",
  general_surgery: "GI/General Surgery",
  urology: "Urology",
  surgical_oncology: "Surgical Oncology",
  ophthalmology: "Ophthalmology",
  gynecology: "Gynecologic surgery",
  internal_medicine: "Internal Medicine",
  cardiology: "Cardiology",
  pulmonology: "Pulmonology",
  gastroenterology: "Gastroenterology",
  endocrinology: "Endocrinology",
  nephrology: "Nephrology",
  neurology: "Neurology",
  hematology: "Hematology",
  medical_oncology: "Medical Oncology",
  rheumatology: "Rheumatology",
}
